export enum AddColorSetViewMode {
  GENERAL = 'GENERAL',
  OPTIONAL_SETTINGS = 'OPTIONAL_SETTINGS',
  ALTERNATIVE_SETS = 'ALTERNATIVE_SETTINGS'
}
